module.exports = __webpack_public_path__ + "be.svg?acececae9f676e129ce71a59bc44d20a";